module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('x-textarea', {
    attrs: {
      "show-counter": "",
      "max": 360,
      "rows": 8,
      "placeholder": "客官，给产品写个好评吧~"
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitComment($event)
      }
    }
  }, [_vm._v("提交评价")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f609ee4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comment.vue
// module id = 665
// module chunks = 1